module.exports = __webpack_public_path__ + "static/media/Logo_Trust_NIAS.acf4497d.png";